import styled from "styled-components";
import { WordPressAPI } from "@/config";

const defaultBg = `${WordPressAPI.media}/2018/11/man-talking-on-the-phone.jpg`;

export const Jumbotron = styled.div`
  background-size: ${props => props.bgCover ? '' : 'cover'};
  background-position-x: center;
  background-position-y: top;
  color: white;
  position: relative;
  background-repeat: no-repeat;
  height: ${props => props.height ? props.height : ''};
  .overlay {
    background: rgba(44, 50, 59, 0.7);
  }
  ${(props) =>
    props.mobileBackground
      ? `
  background-image: url(${props.mobileBackground});
  `
      : `background-image: url(${props.background ? props.background : defaultBg
      });`};
  ${(props) => props.theme.media.md} {
    background-image: url(${(props) =>
    props.background ? props.background : defaultBg});
  }
  ${(props) => props.theme.media.xl} {
    ${(props) =>
    props.alt &&
    "background-size: contain; background-color: #eff4fa; background-position: bottom left;"}
  }

  /* Custom homepage jumbotron styles */
  &.custom-jumbotron {
    background-image: none;

    ${(props) => props.theme.media.md} {
      background-image: url(${(props) => props.background});
    }
  }

  &.client-spotlight {
    background: #fff;

    h1 {
      color: #3F5261;
      font-weight: 500;
    }
  }
 
  &.affiliate {
    background-size: initial;
    ${props => props.theme.media.lg} {
      background-size: cover;
    }
  }

  &.payroll-jumbotron {
    background-size: initial;

    ${props => props.theme.media.xl} {
      background-size: cover;
    }
  }
  
`;

export const Hero = styled.div`
  color: white;
  text-align: center;
  align-items: center;
  justify-content: center;
  padding: 20px 0;

  ${(props) => props.theme.media.xs} {
    padding-top: 60px;
  }

  ${(props) => props.theme.media.sm} {
    display: flex;
    flex-direction: column;
  }

  ${(props) => props.theme.media.md} {
    min-height: ${(props) => (props.Short ? "419px" : "auto")};
  }

  ${(props) => props.theme.media.lg} {
    padding: 60px 0;
  }

  h1 {
    color: #fff;
    margin-bottom: ${(props) => props.Short && "10px"};

    &.faq-title {
      color: #495057;
      font-weight: 500;
    }
    
    &.news-title {
      color: #3F5261;
      font-weight: 500;
      max-width: 20rem;
      margin: 0 auto;

      ${props => props.theme.media.sm} {
        max-width: 25rem;
      }

      ${props => props.theme.media.md} {
        max-width: max-content;
      }
    }
  }
  .sub-header {
    max-width: 820px;
    margin-left: auto;
    margin-right: auto;
  }
  .job-title {
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: 3em;
  }
  p {
    color: white;
    font-weight: 300;
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
    font-size: 0.9375rem;
    ${(props) => props.theme.media.sm} {
      font-size: 1.375rem;
    }
    &.full-width {
      max-width: 100%;
    }
  }
  ul,
  ol {
    max-width: 700px;
    margin: 1em auto;
  }
  .btn {
    margin-top: 15px;
  }

  /* Custom homepage hero styles */
  &.custom-home {
    padding: 40px 0;
    ${(props) => props.theme.media.md} {
      padding: 60px 0 80px;
    }
    ${(props) => props.theme.media.lg} {
      padding: 100px 0 140px;
    }
    ${(props) => props.theme.media.xl} {
      padding: 120px 0 160px;
    }
    ${(props) => props.theme.media.xxl} {
      padding: 120px 0 180px;
    }
    h1 {
      max-width: 10em;
      margin: 0 auto 0.4em;
      line-height: 1.1;
      font-weight: 400;
      ${(props) => props.theme.media.xl} {
        font-size: 5em;
      }
    }
    .sub-header {
      p {
        max-width: 23em;
        line-height: 1.5;
      }
    }
  }

  &.client-spotlight {
    ${props => props.theme.media.md} {
      min-height: auto;
      padding-top: 6rem;
      padding-bottom: 3.3125rem;
    }
  }
  &.news {
    padding-top: 3rem;
    padding-bottom: 2.125rem;
    min-height: auto;

    ${props => props.theme.media.md} {
      padding-top: 9rem;
    }
  }

  .btn-wrap {
    max-width: 22rem;
    margin: 0 auto;

    ${(props) => props.theme.media.md} {
      display: block;
      margin: 0 auto;
      max-width: 22rem;
    }
  }
`;
